import { useSelector } from 'react-redux';
import { additionalQuestionnaires, intakeData } from '../../../constants/questionnaire';
import QuestionnaireItem from './QuestionnaireItem';
import { QuestionnaireContainer, StyledCollapse } from './style';
import { RootState } from '../../../redux/store';
import { useMemo } from 'react';
import { ClientQuestionnaireType } from '../../../types';
import { useNavigate } from 'react-router-dom';
import { Empty } from 'antd';
import NewAIQuestionnaireClient from '../NewAI/Client/NewAIQuestionnaireClient';

interface QuestionnaireProps {
  questionnaireAssignments: ClientQuestionnaireType[];
  client: any;
}

const Questionnaire: React.FC<QuestionnaireProps> = ({ questionnaireAssignments, client }) => {
  const navigate = useNavigate();

  const modifiedQuestionnairesList = useMemo(() => {
    const groupedData: { [key: string]: ClientQuestionnaireType[] } = {};

    questionnaireAssignments?.forEach((data: ClientQuestionnaireType) => {
      const groupKey = data.questionnaire.group === 'intake'
        ? 'intake'
        : 'addtlQuestionnaires';

      if (!groupedData[groupKey]) {
        groupedData[groupKey] = [];
      }

      groupedData[groupKey].push({
        ...data,
      });
    });

    return groupedData;
  }, [questionnaireAssignments]);

  const intakeNotEmpty = useMemo(() => {
    return questionnaireAssignments?.some(
      (assignment: any) => assignment.questionnaire.group === "intake"
    );
  }, [questionnaireAssignments]);

  const addtlQuestionnairesNotEmpty = useMemo(() => {
    return questionnaireAssignments?.some(
      (assignment: any) => assignment.questionnaire.group === ""
    );
  }, [questionnaireAssignments]);

  const onVisitNewQuestionnaire = (questionnaireId: string) => {
    navigate(`questionnaires/${questionnaireId}/new`);
  };

  return (
    <QuestionnaireContainer>
      <StyledCollapse
        expandIconPosition="end"
        size="small"
        ghost
        items={[
          {
            key: '1',
            label: 'Intake',
            children: intakeNotEmpty ? (
              modifiedQuestionnairesList?.intake?.map((data, index) => (
                <QuestionnaireItem
                  key={data.id}
                  title={data.questionnaire.title}
                  date={data.updatedAt}
                  isDone={Boolean(data.response)}
                  onClick={() => onVisitNewQuestionnaire(data.id)}
                />
              ))
            ) : (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <Empty description="No intake questionnaires available" />
              </div>
            )
          }
        ]}
      />
      <StyledCollapse
        expandIconPosition="end"
        size="small"
        ghost
        items={[
          {
            key: '1',
            label: 'Additional questionnaires',
            children: addtlQuestionnairesNotEmpty ? (
              modifiedQuestionnairesList?.addtlQuestionnaires?.map((data, index) => (
                <QuestionnaireItem
                  key={data.id}
                  title={data.questionnaire.title}
                  date={data.updatedAt}
                  isDone={Boolean(data.response)}
                  onClick={() => onVisitNewQuestionnaire(data.id)}
                />
              ))
            ) : (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <Empty description="No additional questionnaires available" />
              </div>
            )
          }
        ]}
      />
      <StyledCollapse
        expandIconPosition="end"
        size="small"
        ghost
        items={[
          {
            key: '1',
            label: 'Biocoherence Assessment',
            children: (
              <NewAIQuestionnaireClient client={client} />
            )
          }
        ]}
      />
    </QuestionnaireContainer>
  )
}

export default Questionnaire;